(() => {
const menuButton = document.querySelector('.menu-button');
const mobileNav = document.querySelector('#mobile-nav');

menuButton?.addEventListener('click', () => {
  const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
  menuButton.setAttribute('aria-expanded', String(!isOpen));
  mobileNav.hidden = isOpen;
});

mobileNav?.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', () => {
    menuButton.setAttribute('aria-expanded', 'false');
    mobileNav.hidden = true;
  });
});

const wellnessProducts = [
  ['DihydroBerberine 250mg, 60 Capsules','dihydroberberine-250mg-60-capsules','Dihydroberberine.png?v=1780184918','29.99'],
  ['Liposomal NAD+ Supplement with Resveratrol, 60 Capsules','liposomal-nad-supplement-with-resveratrol-1000mg-per-serving-60-capsules','NAD.png?v=1780160742','18.99'],
  ['Organic Citrus Bergamot Extract 1400mg, 120 Capsules','citrus-bergamot-extract','Citrus_Bergamot.png?v=1780160848','21.99'],
  ['Thyroid Support with Iodine and BioPerine, 120 Capsules','thyroid-support-complex-with-iodine-bioperine-120-capsules','Thyroid_Support.png?v=1780160778','15.99'],
  ['Berberine and Ceylon Cinnamon 1450mg, 120 Capsules','nutriflair-berberine-with-organic-ceylon-cinnamon-1450mg','Berberine_with_Ceylon_Cinnamon_7f35644f-9154-4ace-a892-ea6f5d2ca6d8.png?v=1780160779','29.99'],
  ['Organic Ashwagandha with Black Pepper 1950mg, 120 Capsules','organic-ashwagandha-capsules-1950mg-120-capsules-with-black-pepper-root-powder','Ashawagandha_Ultra_Pro.png?v=1780160811','15.99'],
  ['Pure TUDCA 1000mg, 60 Capsules','nutriflair-pure-tudca-1000mg','TUDCA.png?v=1780160812','33.99'],
  ['Alpha Lipoic Acid with Grape Seed Extract, 120 Capsules','alpha-lipoic-acid-120-capsules','Alpha_Lipolic_Acid.png?v=1780160812','19.99'],
  ['Ceylon Cinnamon + Berberine and Chromium, 120 Capsules','ceylon-cinnamon-berberine-and-chromium','Ceylon_Cinnamon_with_Berberine.png?v=1780160847','28.99'],
  ['Vitamin D3 5,000 IU, 125 mcg','vitamin-d3-5000-iu','Vitamin_C_Ultra_Strength.png?v=1780160983','9.99'],
  ['Quercetin with Vitamin C & Zinc','quecetin-vitamin-c-zinc','Quercetin_ed08e613-352d-42ca-8c7e-1fa0844cd18d.png?v=1780160847','19.99'],
  ['Organic Irish Sea Moss 1600mg, 120 Capsules','irish-sea-moss-1600mg-for-women-and-men','Sea_moss.png?v=1780160750','17.99'],
  ['Turmeric Curcumin with BioPerine, 180 Capsules','turmeric-curcumin-with-bioperine-nutriflair','Turmeric_Curcumin_f5cabbfe-3492-4f3f-a0cb-baa99a34b887.png?v=1780160756','18.99'],
  ['10 Mushroom Complex Supplement 2600mg, 90 Capsules','10-mushroom-complex-supplement-2600-mg-90-capsules-nutriflair','Mushroom_complex_c9daf1b6-a5ed-4371-9a83-41f82981cf8d.png?v=1780160754','19.99'],
  ['Liposomal Vitamin C 1700mg, 180 Capsules','liposomal-vitamin-c-1600-mg-180-capsules-nutriflair','Liposomal_Vit_c_a75cf2d7-fb1f-4614-b6f6-a080c0646889.png?v=1780160951','20.99'],
  ['Turmeric Curcumin with Ginger 2250mg, 180 Capsules','turmeric-curcumin-with-ginger-2250mg-with-bioperine-nutriflair','Turmeric_fd995f68-39ef-4511-bf35-0c4a0aed3783.png?v=1780160951','18.99'],
  ['Garcinia Cambogia 95% HCA, 90 Capsules','garcinia-cambogia-95-hca-90-capsules-nutriflair','Garcinia_Cambogia.png?v=1780160952','14.99'],
  ['Zinc+ with Vitamin C, Elderberry and Echinacea, 60 Capsules','zinc-50mg-supplement-with-vitamin-c-elderberry-echinacea-60-capsules','Zinc_750d4cd3-a6e8-4018-9a75-ff251bc17043.png?v=1780160983','14.99'],
  ['Vitamin C 2000mg with Zinc and Rose Hips, 120 Capsules','vitamin-c-rose-hips-zinc-2000mg-120-capsules','Vitamin_C_Ultra_Strength.png?v=1780160983','15.99'],
  ['DIM Supplement 400mg with BioPerine, 120 Capsules','dim-supplement-400mg-with-bioperine-120-capsules','DIM.png?v=1780160983','20.99'],
  ['Apple Cider Vinegar Gummies 1000mg, 60 Pieces','apple-cider-vinegar-gummies-60-gummies','ACV_Gummies.png?v=1780161015','12.99'],
  ['Elderberry, Vitamin C, Zinc and Vitamin D3, 120 Capsules','elderberry-vitamin-c-zinc-vitamin-d3-120-capsules','Elderberry.png?v=1780161015','17.99'],
  ['Zinc Picolinate 50mg, 120 Capsules','nutriflair-zinc-picolinate-50mg-120-capsules','Zinc.png?v=1780161017','14.99'],
  ['Zinc Gluconate 50mg, 100 Tablets','nutriflair-zinc-gluconate-50mg-100-tablets','Zinc_Ultra_Strength.png?v=1780161051','11.99'],
  ['Multi Collagen Complex 2250mg, 180 Capsules','multi-collagen-complex','Collagen_Complex.png?v=1780161051','18.99'],
  ['D-Mannose with Cranberry & Dandelion Extract, 120 Capsules','d-mannose-1200mg-120-capsules','D_Mannose.png?v=1780161052','18.99'],
  ['Apple Cider Vinegar plus Keto BHB Salts 1600mg, 120 Capsules','raw-apple-cider-vinegar-capsules-with-the-mother-keto-diet-pills-bhb-salts','ACV_with_KETO.png?v=1780161095','18.99'],
  ['Liposomal Glutathione Setria 700mg, 60 Capsules','liposomal-glutathione-setria-700mg-60-casules-pure-reduced-l-glutathione','Liposomal_Gluta.png?v=1780161088','34.99'],
  ['Korean Red Panax Ginseng 1600mg, 120 Capsules','korean-red-panax-ginseng-1500mg-120-vegan-capsules','Korean_Panax_Ginseng.png?v=1780161193','16.99'],
  ['Berberine HCI 1200mg with Organic Ceylon Cinnamon, 120 Capsules','berberine-hcl-1200mg-plus-organic-ceylon-cinnamon-120-capsules','Berberine_c6e17b2a-9b5a-4a1a-aa19-1f60bab7fae9.png?v=1780161194','27.99'],
  ['Horny Goat Weed 1000mg with Maca Root, 60 Capsules','nutriflair-horny-goat-weed','Horny_Goat_Weed.png?v=1780161363','14.99'],
  ['Glucosamine Chondroitin with Turmeric & MSM, 180 Capsules','glucosamine-chondroitin-turmeric-msm-90-capsules','Glucosamine_da504748-0225-40d4-b844-2df517d4ed15.png?v=1780161545','21.99'],
  ['Keto Diet Pills BHB Salts 1200mg, 90 Capsules','nutriflair-keto-diet-pills-1200mg','KETO.png?v=1780161224','17.99'],
  ['Plant-Based Vitamin K2 + D3, 90 Capsules','vitamin-k2-mk7-with-d3-5000-iu-bioperine-black-pepper-90-capsules','K2_D3.png?v=1780161225','13.99'],
  ['Organic Ashwagandha and Black Pepper 1950mg, 180 Capsules','nutriflair-ashwagandha-with-organic-black-pepper-made-with-certified-organic-ashwagandha-120-veggie-capsules','Ashwagandha.png?v=1780161328','17.99'],
  ['Organic Ceylon Cinnamon 1200mg, 120 Capsules','organic-ceylon-cinnamon-1200mg-per-serving-120-capsules','Ceylon_Cinnamon_dcc194e9-ddd1-4742-a76d-dcc7342b9c5c.png?v=1780161328','19.99'],
  ['Liver Cleanse Detox & Support with Milk Thistle, 60 Capsules','nutriflair-liver-detoxifier-and-support-with-milk-thistle-60-capsules','Liver_Cleanse.png?v=1780161328','13.99'],
  ['Premium Saw Palmetto Berry Extract 750mg, 120 Capsules','nutriflair-saw-palmetto-capsules-natural-prostate-health-support-100-capsules','Saw_Palmetto.png?v=1780161362','14.99'],
  ['15 Day Quick Colon Cleanse & Detox, 30 Capsules','nutriflair-15-day-quick-colon-cleanse-and-detox-30-capsules-advanced-cleansing-formula','Colon.png?v=1780161435','12.99'],
  ['Premium Omega 3 Fish Oil, 180 Softgels','nutriflair-omega-3-fish-oil-supplement','Fish_Oil.png?v=1780161468','19.99'],
  ['Apple Cider Vinegar with the Mother 1600mg, 120 Capsules','apple-cider-vinegar-weight-loss-capsules-120-pills','Apple_Cider_Vinegar_ae492d51-bfe7-4c6a-abcc-5c3a178a5f50.png?v=1780161542','19.99']
].map(([title, handle, image, price]) => ({
  title,
  handle,
  price,
  image: `https://cdn.shopify.com/s/files/1/0020/6143/4943/files/${image}`
}));

const wellnessGoalLabels = {
  energy: 'Energy',
  stress: 'Stress Support',
  metabolism: 'Metabolic Support',
  daily: 'Daily Wellness',
  joint: 'Joint Support',
  immune: 'Immune Support'
};

function getWellnessGoals(title) {
  const name = title.toLowerCase();
  const goals = new Set();
  if (/nad|ginseng|thyroid|sea moss|mushroom|vitamin d3|horny goat|tudca|alpha lipoic/.test(name)) goals.add('energy');
  if (/ashwagandha|mushroom|ginseng/.test(name)) goals.add('stress');
  if (/berberine|bergamot|cinnamon|alpha lipoic|garcinia|apple cider|keto|tudca|liver|thyroid|dim|colon/.test(name)) goals.add('metabolism');
  if (/collagen|omega|sea moss|vitamin [dk]|zinc|d-mannose|saw palmetto|liver|colon|apple cider|dim|fish oil|glutathione/.test(name)) goals.add('daily');
  if (/turmeric|glucosamine|collagen|omega|fish oil/.test(name)) goals.add('joint');
  if (/vitamin c|vitamin d|zinc|quercetin|elderberry|glutathione|sea moss|mushroom|d-mannose/.test(name)) goals.add('immune');
  if (!goals.size) goals.add('daily');
  return [...goals];
}

const wellnessTrack = document.querySelector('#wellness-product-track');
const wellnessTabs = document.querySelectorAll('.wellness-goal-tab');
const wellnessHeading = document.querySelector('#wellness-products-heading');
const wellnessCount = document.querySelector('#wellness-product-count');
const wellnessPrev = document.querySelector('.wellness-slider-prev');
const wellnessNext = document.querySelector('.wellness-slider-next');

function updateWellnessArrows() {
  if (!wellnessTrack) return;
  const end = wellnessTrack.scrollWidth - wellnessTrack.clientWidth - 4;
  wellnessPrev.disabled = wellnessTrack.scrollLeft <= 4;
  wellnessNext.disabled = wellnessTrack.scrollLeft >= end;
}

function renderWellnessProducts(goal = 'energy') {
  if (!wellnessTrack) return;
  const products = goal === 'all'
    ? wellnessProducts
    : wellnessProducts.filter((product) => getWellnessGoals(product.title).includes(goal));

  wellnessTrack.replaceChildren(...products.map((product) => {
    const card = document.createElement('article');
    const link = `https://nutriflair.com/products/${product.handle}`;
    card.className = 'wellness-product-card';

    const imageLink = document.createElement('a');
    imageLink.className = 'wellness-product-image';
    imageLink.href = link;
    imageLink.setAttribute('aria-label', `View ${product.title}`);
    const image = document.createElement('img');
    image.src = product.image;
    image.alt = product.title;
    image.width = 420;
    image.height = 420;
    image.loading = 'lazy';
    const badge = document.createElement('span');
    badge.className = 'wellness-product-badge';
    badge.textContent = goal === 'all' ? 'NutriFlair' : wellnessGoalLabels[goal];
    imageLink.append(image, badge);

    const title = document.createElement('h4');
    title.textContent = product.title;
    const price = document.createElement('p');
    price.className = 'wellness-product-price';
    price.textContent = `$${product.price}`;
    const productLink = document.createElement('a');
    productLink.href = link;
    productLink.textContent = 'View Product';
    card.append(imageLink, title, price, productLink);
    return card;
  }));

  wellnessTrack.scrollLeft = 0;
  wellnessHeading.textContent = wellnessGoalLabels[goal];
  wellnessCount.textContent = `${products.length} ${products.length === 1 ? 'product' : 'products'}`;
  requestAnimationFrame(updateWellnessArrows);
}

wellnessTabs.forEach((tab) => {
  tab.addEventListener('click', () => {
    wellnessTabs.forEach((item) => {
      const selected = item === tab;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-selected', String(selected));
    });
    renderWellnessProducts(tab.dataset.goal);
  });
});

wellnessPrev?.addEventListener('click', () => wellnessTrack.scrollBy({ left: -wellnessTrack.clientWidth * .82, behavior: 'smooth' }));
wellnessNext?.addEventListener('click', () => wellnessTrack.scrollBy({ left: wellnessTrack.clientWidth * .82, behavior: 'smooth' }));
wellnessTrack?.addEventListener('scroll', updateWellnessArrows, { passive: true });
window.addEventListener('resize', updateWellnessArrows);
renderWellnessProducts('energy');

})();
